// hooks/useAppContext.ts
"use client";
import { useContext, createContext, Context } from "react";
import { AppContextData } from "types";

export const AppContext: Context<AppContextData | undefined> = createContext<
  AppContextData | undefined
>(undefined);

export const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error("useAppContext must be used within a AppContextProvider");
  }

  return context;
};
